enum AnimateClasses {
  ANIMATED = 'animate__animated',
  FADE_IN = 'animate__fadeIn',
  FADE_OUT_FAST = 'animate__fadeOut animate__faster',
}

export default AnimateClasses;
